import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Logo from '../../assets/images/Logo-login.png';
import './maintenance.scss';

const { Title, Paragraph, Text } = Typography;

const CONTACT_PHONES = ['04.68.67.36.85', '06.09.27.46.51'];

/**
 * Public maintenance page, reachable without authentication.
 *
 * @component
 * @returns {JSX.Element} The maintenance page.
 */
export const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <main className="maintenance-layout">
      <section className="maintenance-card">
        <img className="maintenance-logo" alt="Ani Seniors" src={Logo} />

        <span className="maintenance-badge">
          <span className="maintenance-badge-dot" />
          {t('maintenance.badge')}
        </span>

        <Title level={1} className="maintenance-title">
          {t('maintenance.title')}
        </Title>

        <Paragraph className="maintenance-text">
          {t('maintenance.description')}
        </Paragraph>
        <Paragraph className="maintenance-text">
          {t('maintenance.deployment')}
        </Paragraph>

        <div className="maintenance-contact">
          <Text className="maintenance-contact-label">
            {t('maintenance.contact')}
          </Text>
          <div className="maintenance-contact-phones">
            {CONTACT_PHONES.map((phone) => (
              <a
                key={phone}
                className="maintenance-contact-phone"
                href={`tel:+33${phone.replace(/\./g, '').slice(1)}`}
              >
                {phone}
              </a>
            ))}
          </div>
        </div>

        <Text className="maintenance-thanks">{t('maintenance.thanks')}</Text>
      </section>

      <footer className="maintenance-footer">
        © {new Date().getFullYear()} Ani Seniors Services
      </footer>
    </main>
  );
};
